import { render, staticRenderFns } from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=template&id=07e7ea18"
import script from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=script&lang=js"
export * from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=script&lang=js"
import style0 from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=style&index=0&id=07e7ea18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.1.1_webpack@5.108.2_postcss@8.5.16___1b790b54f7ec47b93c925242303ba546/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports